export default {
  common: {
    explore: '探索画廊',
    viewAll: '查看全部作品',
    scanQR: '请使用手机扫描二维码',
  },
  home: {
    hero: {
      title: 'We made these memories for ourselves',
    },
    featured: {
      title: '精选作品',
    },
    about: {
      title: '关于摄影师',
      content: '我是一位热爱光影与情感的摄影师，始终相信摄影不仅是记录，更是连接 —— 它能唤醒被我们遗忘的时间、治愈我们曾经的伤痛，也让那些短暂的片刻，在照片中永远定格。聚焦真实而细腻的人物故事、情感流动的瞬间，无论是一场婚礼、一段旅程，还是一双对视的眼睛，希望在按下快门的那一刻，封存爱与记忆。希望当你翻看这些照片时，能再次感受到那一刻的心动与温度。',
      quote: 'We keep this love in a photograph, we made these memories for ourselves.',
    },
    footer: {
      portfolio: '作品集',
      gallery: '画廊',
      copyright: '© {{year}} Swain Photography. All rights reserved.',
    },
  },
  gallery: {
    all: '全部',
    landscape: '风景',
    portrait: '人像',
    documentary: '纪实',
    wedding: '婚礼',
    ecosystem: '生态',
    aircraft: '航空',
  },
  social: {
    douyin: '抖音',
    weibo: '微博',
    rednote: '小红书',
    wechat: '微信',
  },
}; 